import { render, staticRenderFns } from "./CampoVisual.vue?vue&type=template&id=b87b000e"
import script from "./CampoVisual.vue?vue&type=script&lang=js"
export * from "./CampoVisual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports